// extracted by mini-css-extract-plugin
export var button = "dropdown-nav-module--button--1EDnZ";
export var container = "dropdown-nav-module--container--J-n5K";
export var dropdown = "dropdown-nav-module--dropdown--UCoO8";
export var linkEl = "dropdown-nav-module--linkEl--neNOk";
export var open = "dropdown-nav-module--open--8ibI9";